(function () {
  const wrapper = document.querySelector(".mobile-menu-wrapper");
  const button = document.querySelector(".mobile-menu-button");
  const overlay = document.querySelector(".mobile-menu-overlay");

  if (!wrapper || !button || !overlay) return;

  const toggle = () => {
    const isOpen = wrapper.classList.toggle("mobile-menu-open");
    document.body.style.overflow = isOpen ? "hidden" : "";
  };

  const close = () => {
    wrapper.classList.remove("mobile-menu-open");
    document.body.style.overflow = "";
  };

  button.addEventListener("click", toggle);
  overlay.addEventListener("click", close);
})();
